import useSEO from "../hooks/useSEO";
import { motion } from "framer-motion";
import { Code2, Cloud, Bot, Workflow, Home as HomeIcon } from "lucide-react";
import PageHero from "../components/PageHero";
import WhySefkam from "../components/WhySefkam";
import HowWeWork from "../components/HowWeWork";
import CTASection from "../components/CTASection";
import { Reveal } from "../lib/motion";

const COMBINES = [
  { icon: Code2, label: "Software engineering" },
  { icon: Cloud, label: "Cloud technologies" },
  { icon: Bot, label: "Artificial intelligence" },
  { icon: Workflow, label: "Automation" },
  { icon: HomeIcon, label: "Connected devices" },
];

export default function About() {
  useSEO({
    title: "About | SefKam Digital Solutions",
    description: "SefKam Digital Solutions is a technology company focused on building practical software, AI, automation, and connected experiences.",
    path: "/about",
  });
  return (
    <>
      <PageHero
        eyebrow="About SefKam"
        title="Technology with a builder's mindset."
        subtitle="SefKam Digital Solutions is a technology company focused on building practical software, AI, automation, and connected experiences."
      />

      <section className="bg-white py-24 md:py-32" data-testid="about-content">
        <div className="container-x grid gap-16 lg:grid-cols-[1.2fr_1fr]">
          <div>
            <Reveal>
              <p className="font-display text-2xl font-light leading-relaxed tracking-tight text-[#07111F] sm:text-3xl">
                We're a small but highly capable team that combines engineering depth with an
                ambition to build our own intelligent products — starting with SefKam Home.
              </p>
            </Reveal>
            <Reveal delay={0.1}>
              <p className="mt-8 max-w-xl text-base leading-relaxed text-slate-500">
                Our focus is practical: understand the business problem, design a sound architecture,
                and ship systems that keep working as they grow. We apply AI where it adds real,
                measurable value — and we're honest about where it doesn't.
              </p>
            </Reveal>
          </div>

          <div>
            <Reveal>
              <span className="overline text-slate-400">What we combine</span>
            </Reveal>
            <div className="mt-6 space-y-3">
              {COMBINES.map((c, i) => {
                const Icon = c.icon;
                return (
                  <motion.div
                    key={c.label}
                    initial={{ opacity: 0, x: 16 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6, delay: i * 0.07 }}
                    className="flex items-center gap-4 rounded-2xl border border-slate-200 bg-[#F8FAFC] p-4"
                    data-testid={`about-combine-${i}`}
                  >
                    <span className="grid h-10 w-10 place-items-center rounded-xl bg-[#07111F] text-cyan-300"><Icon size={18} strokeWidth={1.8} /></span>
                    <span className="text-sm font-medium text-[#07111F]">{c.label}</span>
                  </motion.div>
                );
              })}
            </div>
          </div>
        </div>
      </section>

      <WhySefkam />
      <HowWeWork />
      <CTASection />
    </>
  );
}
